import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'documentType',
    label: 'Document',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'receivedDate',
    label: 'Received Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'toInvestorDate',
    label: 'To Investor Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'documentRecordingAmount',
    label: 'Recording Amount On Document',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'finalCdRecordingAmount',
    label: 'Recording Amount From Final CD',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'comments',
    label: 'Comments',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const documentsListForm = {
  name: FormNames.POST_CLOSING,
  label: 'Documents List',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
